import { DEFAULT_GRID_ID, MAIN_VIEW_ID } from "@/consts/consts";

/**
 * @class MainView
 * @property {Array<string|number>} cams Cameras ids: [cam1id,cam2id,cam3id,...]
 * @property {number} grid View grid: 4
 * @property {string} id View id: main
 * @property {string} name View name: tabs.mainView
 * @property {boolean} changed don't know
 * @property {boolean} temp don't know
 * @property {boolean} isGlobalView is global view flag
 */

export class MainView {
  constructor() {
    this.id = MAIN_VIEW_ID;
    this.name = "tabs.mainView";
    this.cams = [];
    this.grid = DEFAULT_GRID_ID;

    this.changed = false;
    this.temp = true;

    this.isGlobalView = false;
  }
}



// WEBPACK FOOTER //
// ./src/classes/views/mainView.js